export enum CurrentTransactionActionTypes {
  Update = 'Update',
  Reset = 'Reset',
}
